import { Box } from '@mui/material';
import { TextFieldFormik } from '@vxui/components';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const inputSize = 'small';

type UserFormProps = {
  isCreate?: boolean;
};

export const UserForm: FC<UserFormProps> = ({ isCreate = true }) => {
  const { t } = useTranslation();
  const label = useCallback((fieldName: string) => t(`auth.forms.user.fields.${fieldName}.title`), [t]);
  const placeholder = useCallback((fieldName: string) => t(`auth.forms.user.fields.${fieldName}.placeholder`), [t]);

  return (
    <Box marginBottom="20px" component="form">
      {/* <TextFieldFormik
        name="username"
        size={inputSize}
        label={label('username')}
        placeholder={placeholder('username')}
      /> */}
      <TextFieldFormik
        name="login"
        size={inputSize}
        label={label('login')}
        placeholder={placeholder('login')}
        autoComplete="username"
        disabled={!isCreate}
      />
      {isCreate && (
        <>
          <TextFieldFormik
            name="password"
            size={inputSize}
            label={label('password')}
            placeholder={placeholder('password')}
            type="password"
            autoComplete="new-password"
          />
          <TextFieldFormik
            name="confirmedPassword"
            size={inputSize}
            label={label('confirmedPassword')}
            placeholder={placeholder('confirmedPassword')}
            type="password"
            autoComplete="new-password"
          />
        </>
      )}
      {/* <SelectBoxFormik name="role" size={inputSize} label={label('role')} placeholder={placeholder('role')}>
        <MenuItem value={UserRole.Admin}>{t(`auth.forms.user.fields.role.options.${UserRole.Admin}`)}</MenuItem>
        <MenuItem value={UserRole.User}>{t(`auth.forms.user.fields.role.options.${UserRole.User}`)}</MenuItem>
      </SelectBoxFormik> */}
    </Box>
  );
};
